import { React, useState } from 'react'
import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import Sidebar from './Sidebar';
import { BsListOl } from "react-icons/bs";
// import PractitionerTable from './AdminComponents/PractionerTable';
// import OrdersTable from './AdminComponents/OrdersTable';

import PropertyTypeTable from './AdminComponents/PropertyTypeTable';

const PropertyType = () => {

  const [isOpen, setOpen] = useState(false);
  // const [isClose, setClose] = useState(false);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };
  return (
    <>
      <div className="dashboard">
        <div className={isOpen ? 'd-flex toggled' : 'd-flex'} id="wrapper">
          <Sidebar />
          <div className="page-content">
            <nav className="navbar navbar-expand-lg navbar-black">
              <div className="d-flex align-items-center py-3 ps-3 d-lg-none">
                <button className='togl-btn' onClick={toggleOpen} role="button"><i className="fa-solid fa-bars primary-text fs-4 me-3" id="menu-toggle"></i></button>

              </div>
              <AdminHeader />
            </nav>
            {/* <!-- Areas --> */}
            <div className="dashboard-page p-4">
              {/* contact form starts*/}
              <div className="contact dashboard-form">
              <div className="container">
                <div className="contact-sub-head text-end mb-3">
                   
                </div>
                <PropertyTypeTable/>
              </div>
              </div>

              {/* contact form ends */}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default PropertyType